import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { AppStore } from "../../store";
import { CookiePolicyActions } from "../../store/cookie-policy/actions";
import { colours } from "../../styles/colours";
import { device } from "../../styles/media";
import { Button } from "../button";
import { Cover, Flex } from "../layout";
import { GlobalOverlayContext } from "../overlay/context";
import { CookiePreferences } from "./preferences";
import { CookiePreferences as CookiePreferencesType } from "../../store/cookie-policy/models";
import { useTranslation } from "react-i18next";

const Container = styled.div<{ hide?: boolean }>`
  ${Cover};
  top: auto;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  color: ${colours.white};
  width: 100%;
  transition: max-height 0.3s ease-in-out;
  max-height: ${(props) => (props.hide ? "0" : "500px")};
  z-index: 1;
`;

const Wrapper = styled(Flex)`
  padding: 2em;
  flex-direction: column;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

const Description = styled.p`
  flex-grow: 1;
`;

const CTA = styled(Button)`
  display: block;
  margin-top: 1em;
  width: 100%;

  @media ${device.laptop} {
    width: auto;
    margin-left: 1em;
  }
`;

const StyledCookiePreferences = styled(CookiePreferences)`
  font-size: 0.8em;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media ${device.laptop} {
    font-size: 1em;
  }
`;

export const CookiePolicy = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("cookie-policy");
  const { setOverlay } = useContext(GlobalOverlayContext);
  const show = useSelector<AppStore, boolean>(
    (store) => store.cookiePolicy.showBar
  );

  return (
    <Container hide={!show}>
      <Wrapper>
        <Description
          dangerouslySetInnerHTML={{
            __html: t("description"),
          }}
        ></Description>
        <CTA
          colour="warning"
          onClick={() =>
            setOverlay({
              children: (
                <StyledCookiePreferences
                  onSelectPreferences={(pref: CookiePreferencesType) => {
                    dispatch(CookiePolicyActions.setCookiePreferences(pref));
                    setOverlay({
                      children: null,
                      title: "",
                    });
                  }}
                />
              ),
              title: t("title"),
            })
          }
        >
          {t("preferences")}
        </CTA>
        <CTA
          colour="primary"
          variant="outlined"
          onClick={() => dispatch(CookiePolicyActions.declineCookies())}
        >
          {t("decline")}
        </CTA>
        <CTA
          colour="primary"
          variant="outlined"
          onClick={() => dispatch(CookiePolicyActions.acceptCookies())}
        >
          {t("accept")}
        </CTA>
        <CTA
          colour="primary"
          onClick={() => {
            dispatch(
              CookiePolicyActions.setCookiePreferences({
                ad_storage: "granted",
                analytics_storage: "granted",
                functionality_storage: "granted",
                personalization_storage: "granted",
                security_storage: "granted",
              })
            );
            dispatch(CookiePolicyActions.acceptCookies());
          }}
        >
          {t("accept-all")}
        </CTA>
      </Wrapper>
    </Container>
  );
};
